export default __webpack_public_path__ + "static/media/monsanto.57a30775.jpg";